import styled from 'styled-components';
import { ToolbarButton } from '../../../Common/styled/Button';

export const StyledGroupedToolsButtons = styled.div`
  z-index: 9999;
  top: ${(props) => (props.groupedToolsYPosition ? `${props.groupedToolsYPosition}px` : '100%')};
  left: ${(props) => props.groupedToolsXPosition}px;
  transform: translateX(-30%);
  width: -moz-fit-content;
  width: fit-content;
  position: fixed;
  display: grid;
  grid-template-columns: repeat(3, minmax(60px, 1fr));
  justify-content: center;
  align-items: center;
  gap: 1em;
  background-color: ${(props) => props.theme.colors.black};
  padding: 10px;
  border: 1px solid #F5F5F57F;
  border-radius: 6px;

  ${ToolbarButton} {
    span {
      color: ${(props) => props.theme.colors.gray700};
    }

    svg {
      fill: ${(props) => props.theme.colors.gray700};
      stroke: ${(props) => props.theme.colors.gray700};
    }

    @media (hover: hover) {
      :hover {
        span {
          color: ${(props) => props.theme.colors.smokeWhite};
        }

        svg {
          fill: ${(props) => props.theme.colors.smokeWhite};
          stroke: ${(props) => props.theme.colors.smokeWhite};
        }
      }
    }
  }

  @media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
    position: fixed;
    transform: none;
    z-index: 9999;
    display: grid;
    grid-template-columns: repeat(3, minmax(60px, 1fr));
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    box-sizing: border-box;
    width: fit-content;
    height: auto;
    margin: 0;
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
    max-width: calc(100vw - 2rem);
    background-color: ${(props) => props.theme.colors.black};
    gap: 0.75rem;
    padding: 0.75rem;
  }

  @media screen and (max-width: ${(props) => props.theme.sizes.mobile}) {
    width: fit-content;
    max-width: calc(100vw - 1rem);
    max-height: calc(100vh - 1rem);
    max-height: calc(100dvh - 1rem);
    gap: 0.5rem;
    padding: 0.5rem;
  }
`;

export const StyledGroupedToolsButtonsContainer = styled.div``;
